export default __webpack_public_path__ + "static/media/GaliciaGordon.0e69d675.jpg";